module.exports = __webpack_public_path__ + "img/9.db5072e9.png";